import React from 'react';
import {NavLink} from "react-router-dom";
import FadeSlideIn from "../../common/FadeSlideIn";
import {ReactComponent as DiscordIcon} from "../../../resources/svg/discord.svg";
import {ReactComponent as KickIcon} from "../../../resources/svg/kick.svg";
import {ReactComponent as InstaIcon} from "../../../resources/svg/insta.svg";
import {ReactComponent as TwitterIcon} from "../../../resources/svg/twitter.svg";
import {ReactComponent as YoutubeIcon} from "../../../resources/svg/youtube.svg";

const LandingSocials = () => {
    return (<FadeSlideIn>
        <div className="container landingSocials">

            <div className="landingSocialsOuter">
                <h1>Social Media</h1>
                <p>Follow me on Social Media to stay up to date!</p>

                <div className="landingSocialsWrapper">

                    <NavLink to={""} className="landingSocial"><TwitterIcon className={"twitter"} /></NavLink>
                    <NavLink to={""} className="landingSocial"><InstaIcon className={"insta"} /></NavLink>
                    <NavLink to={""} className="landingSocial"><YoutubeIcon className={"youtube"} /></NavLink>
                    <NavLink to={""} className="landingSocial"><KickIcon className={"kick"} /></NavLink>
                    <NavLink to={""} className="landingSocial"><DiscordIcon className={"discord"} /></NavLink>

                </div>
            </div>

        </div>
    </FadeSlideIn>);
}
export default LandingSocials;